// Single source of truth for fixture mode (dev/QA only). NEXT_PUBLIC_FIXTURES
// is inlined at build time; the guard makes a production build with the flag
// fail at module load instead of silently shipping with auth bypassed.
if (process.env.NEXT_PUBLIC_FIXTURES === '1' && process.env.NODE_ENV === 'production') {
  throw new Error('NEXT_PUBLIC_FIXTURES=1 must never be set in a production build')
}

export const FIXTURES = process.env.NEXT_PUBLIC_FIXTURES === '1'
